import Backbone from "backboneAdapter";
import moment from "moment";
import "moment-timezone";
import dhtmlx from "dhtmlxAdapter";
import i18n from "l10n";
import LoginView from 'views/login.view';
import RegistrationView from 'views/registration.view';
import ThirdPartyConfirmRegistrationView from 'views/thirdPartyConfirmRegistration.view';
import ConfirmRegistrationView from "views/confirm.registration.view";
import PasswordResetView from "views/passreset.view";
import PasswordRecoverView from "views/passrecover.view";
import {bootstrap as FBSDKLoader} from 'fbSdkLoader';
import {delegateEvent} from "../utils/event.delegator";

const LoginRouter = Backbone.Router.extend({
    views: {
        registration: RegistrationView,
        login: LoginView,
        thirdPartyConfirm: ThirdPartyConfirmRegistrationView,
        confirmRegistration: ConfirmRegistrationView,
        passReset: PasswordResetView,
        passRecover: PasswordRecoverView
    },
    routes: {
        "": "defaultRoute",
        "Registration": "registrationRoute",
        "ConfirmRegistration/:registrationToken": "confirmRegistrationRoute",
        "PasswordReset/:resetToken": "passResetRoute",
        "PasswordRecover": "passRecoverRoute",
        "ThirdParty/:provider/Confirm": "thirdPartyConfirmRoute",
        "msg/:type": 'messageRoute',
        ":secureToken/:id": 'loginWithSecureToken'
    },
    initialize: function () {
        console.info("Initializing Login Router");
        this.on("navigation", fragment => this.navigate(fragment, {trigger: true}));
        this.fbApiFuture = FBSDKLoader(i18n.language === "el" ? "el_GR" : "en_US");
    },
    messageRoute(type) {
        let self = this;
        if (type === "nf" || type === "notRegistered") {
            dhtmlx.confirm({
                type: "confirm",
                text: i18n.t("login.msg-" + type),
                ok: i18n.t("message.yes"),
                cancel: i18n.t("message.no"),
                callback: function (result) {
                    if (result) {
                        self.navigate('Registration', {trigger: true});
                    }
                }
            });
        } else if (type === "missingEmail") {
            dhtmlx.alert(`${i18n.t("login.facebook_register_missing_email")}<br/><a href='#' id='reaskPermissionForEmail'>${
                i18n.t("login.reask_permission_for_email")}</a>`);
            $("#reaskPermissionForEmail").click(async function () {
                var url = '/CampaignCloud/oauthClient/startAuthentication';
                var formValues = {
                    provider: 3, //facebook
                    state: 'registration',
                    reaskPermissions: true,
                    permissions: "email"
                };

                try {
                    let {status, LocationUri} = await $.ajaxDefaultQ({
                        url: url,
                        type: 'POST',
                        dataType: "json",
                        data: formValues
                    });

                    if (status === 'success') {
                        console.info(LocationUri);
                        window.open(LocationUri, '_self');
                    } else if (status === 'fail') {
                        dhtmlx.alert(i18n.t("login.registrationerror"));
                    }
                } catch (e) {
                    console.error(e);
                }
            });
        } else {
            if (type !== "alreadyRegistered") {
                dhtmlx.alert(i18n.t("login.msg-" + type));
            }
        }
        this.defaultRoute(type === "alreadyRegistered" ? "#msg/alreadyRegistered" : null);
    },
    bindViewEvent: function () {
        delegateEvent(this.view, this, "navigation")
    },
    async defaultRoute(options) {
        console.info("loginRouter");
        this.resetView();
        if (this.isPostpaid) {
            $("#tellyBottom").css('display', 'none');
            $("#tel").css('display', 'none');
            $("#otherLogin").css('visibility', 'hidden');
            if (!localStorage.acceptedTC) {
                $("#terms-and-conditions").show();
            }
            var $login = $("#login-button");
            $login.prop("disabled", true);
            $login.css({"background-color": "gray", "cursor": "not-allowed"});
            this.view = new this.views.login({isPostpaid: true, fbApiFuture: this.fbApiFuture});
            this.bindViewEvent();
        } else {
            $("#win").css('display', 'none');
            $("#otherLogin").show();
            $("#terms-and-conditions").hide();
            this.view = new this.views.login({isPostpaid: false, fbApiFuture: this.fbApiFuture});
            this.bindViewEvent()
        }
    },
    async ping() {
        let jqXHR;
        try {
            jqXHR = $.ajaxDefaultQ({
                url: '/CampaignCloud/RememberMeController/ping',
                type: 'GET',
                dataType: "json"
            });
            let response = await jqXHR;
            if (jqXHR.getResponseHeader("isPostpaid") === "true") {
                $("#login-button").prop("disabled", true);
            }
            if (response.status === 'success') {
                console.info(response);
                window.open("Dashboard.htm", '_self');
            }

        } catch (e) {
            console.log(e);
            if (!jqXHR) return;
            window.csrf = jqXHR.getResponseHeader('X-CSRF-TOKEN');
            return jqXHR.getResponseHeader("isPostpaid") === "true";
        }
    },
    resetView: async function () {
        this.clearView();
        if (this.isPostpaid === undefined)
            this.isPostpaid = await this.ping();
    },
    async registrationRoute() {
        await this.resetView();
        this.view = new this.views.registration({isPostpaid: this.isPostpaid, fbApiFuture: this.fbApiFuture});
        this.bindViewEvent()
    },
    async confirmRegistrationRoute(registrationToken) {
        await this.resetView();
        this.view = new this.views.confirmRegistration({
            isPostpaid: this.isPostpaid,
            registrationToken: registrationToken
        });
        this.bindViewEvent()
    },
    async passResetRoute(passResetToken) {
        await this.resetView();
        this.view = new this.views.passReset({isPostpaid: this.isPostpaid, resetToken: passResetToken});
    },
    async passRecoverRoute() {
        await this.resetView();
        this.view = new this.views.passRecover({isPostpaid: this.isPostpaid});
    },
    async thirdPartyConfirmRoute(provider) {
        this.resetView();
        const initOpts = {
            isPostpaid: this.isPostpaid,
            provider: provider
        };
        this.view = new this.views.thirdPartyConfirm(initOpts);
        this.bindViewEvent()
    },
    async loginWithSecureToken(secureToken, id) {
        let deferred;
        try {
            deferred = $.ajaxDefaultQ({
                url: '/CampaignCloud/RememberMeController/ping',
                type: 'GET',
                dataType: "json"
            });
            let response = await deferred;
            window.csrf = deferred.getResponseHeader('X-CSRF-TOKEN');
        } catch (e) {
            window.csrf = deferred.getResponseHeader('X-CSRF-TOKEN');
        }
        var postValues = {
            secureToken: secureToken,
            id: id
        };
        try {
            let response = await $.ajaxDefaultQ({
                url: '/CampaignCloud/sso/validate',
                type: 'post',
                data: postValues,
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('X-TZ-Offset', -(new Date()).getTimezoneOffset());
                    xhr.setRequestHeader('X-TZ-Name', moment.tz.guess());
                    xhr.setRequestHeader('X-CSRF-TOKEN', window.csrf);
                }
            });
            if (response.status === 'success') {
                console.info(response);
                window.open('Dashboard.htm', '_self');
            }
        } catch (e) {
            console.error(e);
        }
    },
    clearView() {
        if (this.view) {
            this.view.isRemoved = true;
            this.view.stopListening();
            this.view.$el.empty();
            delete this.view;
        }
    }
});

export {LoginRouter as default};